import {
  RECEIVE_ACTION_TYPE_REASONS,
  RECEIVE_REASONS_MAP,
  RECEIVE_SIMPLE_REASON_IDS,
  RECEIVE_IS_FETCHING_REASONS,
} from '../../actions/reasons';

export const initialState = {
  simpleReasonIds: [],
  itemIdsToReasonIds: {},
  reasonsMap: {},
  actionTypeReasonsByItemId: undefined,
  isFetching: false,
};

export default (
  state = initialState,
  { type, data: { reasonsMap, simpleReasonIds, actionTypeReasonsByItemId, isFetching } = {} } = {},
) => {
  switch (type) {
    case RECEIVE_REASONS_MAP:
      return {
        ...state,
        reasonsMap,
      };

    case RECEIVE_SIMPLE_REASON_IDS:
      return {
        ...state,
        simpleReasonIds,
      };

    case RECEIVE_ACTION_TYPE_REASONS:
      return {
        ...state,
        actionTypeReasonsByItemId,
      };

    case RECEIVE_IS_FETCHING_REASONS:
      return {
        ...state,
        isFetching,
      };

    default:
      return state;
  }
};
